import { Box, Container, Heading } from '@joinrepublic/dls-ui-kit';

import { containerSize } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import { SECTION_PADDING_X } from './constants';
import { GrowthStageVenturesRail } from './growth-stage-ventures-rail/growth-stage-ventures-rail';
import { RealWorldAssets } from './real-world-assets/real-world-assets';

/**
 * The US homepage's window onto /investment-opportunities: the same real-world
 * assets rail and the same deal cards that page shows, cut down to two rails and
 * a way through to the rest.
 *
 * Rendered in place of `Opportunities` for `region === 'us'` — see
 * `apps/republic/pages/index.page.tsx`.
 *
 * Below `md` both subsections stop being scrollers and become lists ending in a
 * full-width "See all", which each one owns — see their `mobileLayout` props.
 * Every "See all" in the block, links and buttons alike, reports the same
 * `see_all_clicked` event, so they are one number in the funnel. Splitting them
 * would need a position param on `TInvestmentOpportunitiesSeeAllClicked`; until
 * somebody wants that split, one number is the honest one.
 *
 * Unlike its neighbouring sections this one is on DLS colour tokens rather than
 * the hardcoded hex in `config/styles.ts`, because the rails and cards it reuses
 * are. Converging is USMKT-1457's job.
 * TODO: https://linear.app/republic/issue/USMKT-1457/change-all-hardcoded-colours-for-the-new-hp-to-the-proper-tokens
 */
export const InvestmentOpportunities = () => {
  return (
    <Container
      as="section"
      id="investment-opportunities"
      maxW={containerSize}
      // Chakra's `Container` default, and so the left margin every other
      // homepage section's copy sits on. The rails are told to cancel exactly
      // this rather than the section being padded to suit their defaults —
      // see `SECTION_RAIL_BLEED` in ./constants.
      px={SECTION_PADDING_X}
      pt={{ base: '10', sm: '24' }}
      pb={{ base: '16', sm: '20' }}
    >
      <MotionBox>
        {/*
          A step up from the `title-md` the sibling sections use, so the two rail
          headings below it read as subordinate rather than as three peers — the
          rails are pinned to funded ventures' own heading size, so the hierarchy
          has to come from this end.

          Flat rather than responsive: the mobile design wants 36px/40px here,
          which is `title-lg`'s own base.
        */}
        <Heading as="h2" size="title-lg" noDefaultSpacing>
          Investment opportunities
        </Heading>

        <Box mt={{ base: '10', md: '12' }}>
          <RealWorldAssets />
        </Box>

        <Box mt={{ base: '10', md: '18' }}>
          <GrowthStageVenturesRail />
        </Box>
      </MotionBox>
    </Container>
  );
};
